import { GET } from "../APiHelper/API";

export const getCurrentUser = (onSuccess, onError) => {
  GET("/api/v1/users/current_user", onSuccess, onError);
};
